/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

/**
 * Deeply access model attributes by passing in a JSON path. Also accepts an
 * optional default value if the attribute being accessed doesnt exist.
 * @param {Backbone.Model} model
 * @param {string} path
 * @param {any} [defaultValue]
 * @returns
 */
export default function modelGet(model, path, defaultValue) {
  return _.get(model.attributes, path, defaultValue);
}
